export function isFreeTierVendorOrPlanner(accountType, payment) {
	return (accountType === 'vendor' || accountType === 'kazoo-planner') && (!payment || payment === 'free-tier')
}
